<template>
    <div>
        <!-- create contact edit -->
        <d-contact-edit
            v-model      = "create"
            :contact-id  = "contact ? contact.id : null"
            :company-id  = "companyId ? companyId : customerId"
            :customer-id = "customerId"
            :mode        = "mode"
            @saved       = "onSaved"
        />
        <!-- create contact edit -->

        <!-- contact combine -->
        <d-contact-combine
            v-model   = "combine"
            :contact  = "contact"
            :contacts = "items"
            @combined = "onCombined"
        />
        <!-- contact combine -->

        <c-card-iterator
            :label         = "$t('contact.title')"
            v-if           = "items"
            :items         = "items"
            :item-height   = "190"
            :filter-height = "180"
            :pagination-on = "true"
            :total-visible = "5"
            :filter        = "contactFilter"
            :key           = "refresh"
            class          = "w-100"
            ref            = "iterator"
        >
            <template v-slot:toolbar>
                <div class="pl-1" style="margin-top: -2px">
                    <c-toolbar-button
                        :size    = "20"
                        icon     = "mdi-account-plus"
                        color    = "white"
                        :tooltip = "$t('contact.create')"
                        @click   = "onCreate"
                    />
                </div>
            </template>

            <template v-slot:filter>
                <v-row class="no-frame mt-2" v-if="customerId">
                    <v-col class="no-frame pr-2 col-5">
                        <v-checkbox
                            label   = "Kontakt Kunde"
                            v-model = "filter.customer"
                            class   = "mt-0 contract-label"
                            :ripple = "false"
                            @change = "onChange"
                            hide-details
                        />
                    </v-col>
                    <v-col class="no-frame pl-0 col-7">
                        <v-checkbox
                            label  = "Kontakt vor Ort"
                            v-model = "filter.onsite"
                            class   = "mt-0 contract-label"
                            :ripple = "false"
                            @change = "onChange"
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame mt-2">
                    <v-col class="no-frame col-5">
                        <v-checkbox
                            label   = "Aktiv"
                            v-model = "filter.active"
                            class   = "mt-0 contract-label"
                            :ripple = "false"
                            @change = "onChange"
                            hide-details
                        />
                    </v-col>
                    <v-col class="no-frame col-7">
                        <v-checkbox
                            v-if    = "selectable"
                            label   = "nur Kundenkontakte"
                            v-model = "filter.customerContact"
                            class   = "mt-0 contract-label"
                            :ripple = "false"
                            @change = "onOnlyAssignedContact"
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame mt-2">
                    <v-col class="no-frame col-5">
                        <v-checkbox
                            label  = "inaktiv"
                            v-model = "filter.inactive"
                            class   = "mt-0 contract-label"
                            :ripple = "false"
                            @change = "onChange"
                            hide-details
                        />
                    </v-col>
                    <v-col class="no-frame col-7">
                        <v-checkbox
                            label   = "Zum Löschen vorgemerkt"
                            v-model = "filter.remove"
                            class   = "mt-0 contract-label"
                            :ripple = "false"
                            @change = "onChange"
                            hide-details
                        />
                    </v-col>
                </v-row>
            </template>

            <template v-slot:card="{ item }">
                <c-contact-card
                    :contact         = "item"
                    :background      = "background(selected, item)"
                    :customer-id     = "customerId"
                    :mode            = "mode"
                    :combine-allowed = "true"
                    @saved           = "onSaved"
                    @selected        = "onSelected(item)"
                    @combine         = "onCombine"
                />
           </template>
        </c-card-iterator>
    </div>
</template>

<script>

import Company         from "@/modules/msd/company/common/service/Company";
import Core            from "@/modules/core/service/Core";
import CCardIterator   from "@/modules/core/components/utils/CCardIterator";
import CToolbarButton  from "@/modules/core/components/utils/CToolbarButton";
import CContactCard    from "@/modules/msd/company/contact/components/controlls/CContactCard";
import Contact         from "@/modules/msd/company/contact/service/Contact";
import DContactCombine from "@/modules/msd/company/contact/components/controlls/DContactCombine";
import DContactEdit    from "@/modules/msd/company/contact/components/controlls/DContactEdit";

export default {
    name: "CContactCardIterator",

    components: {
        DContactEdit,
        DContactCombine,
        CContactCard,
        CToolbarButton,
        CCardIterator,
    },

    props: {
        items: {

        },

        companyId: {

        },

        contractId: {

        },

        customerId: {

        },

        mode: {
            required: false,
            type    : String,
            default : () => {
                return null;
            }
        },

        combineAllowed: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
    },

    data: () => ({
        refresh        : 0,
        create         : false,
        combine        : false,
        selected       : null,
        contact        : null,
        dropoverContact: null,
        managers       : [],
        filter: {
            customer: true,
            onsite  : true,
            active  : true,
            inactive: false,
            remove  : false,
            customerContact: true
        },

        selectable: null,
    }),

    mounted() {
        this.setSelectable();
    },

    watch: {
        contractId () {
            if (this.contractId) {
                this.selected = null;
            }
        },

        customerId () {
            this.setSelectable ();
        },

        companyId () {
            this.setSelectable();
        }
    },

    methods: {
        onCreate () {
            this.contact = {
                id: -1
            };

            this.create = true;
        },

        onSelected (contact) {
            if (this.selected && this.selected.id === contact.id) {
                this.selected = null;
                Core.fire.selected(this, null);
                return;
            }

            this.selected = contact;
            Core.fire.selected(this, this.selected);
        },

        onSaved (contact) {
            const index = this.items.findIndex(c => c.id === contact.id);
            if (index >= 0) {
                this.items[index] = contact;
            } else {
                this.items.unshift (contact);
                this.selectable.push (contact)
            }

            this.refresh ++;
        },

        onCombine (contact) {
            this.contact = contact;
            this.combine = true;
        },

        onCombined () {

        },

        onDrop (data) {
            if (data.type !== 'site') {
                return;
            }

            Contact.assign(this.dropoverContact, data.data).then (() => {
                Core.message.hint(this, this.$t("unit.message.assigned", [ data.data.fabricNo ]));
            }).catch(error => {
                error.then (data => Core.message.error(this, this.$t(data.id, data.parameter), true))
            });

            this.dropoverContact = null;
        },

        onChange () {
            this.$refs.iterator.filterItems();
        },

        onOnlyAssignedContact () {
            this.setSelectable();
        },

        /**
         * Calculates the selectable contacts. If the "Customer Contact" filter is set, only contacts will be
         * retrieved which have already been assigned to a unit of the specified customer. If a service company
         * is selected only contacts of the selected company are considered.
         */
        setSelectable () {
            if (!this.customerId) {
                this.selectable = null;
                return;
            }

            if (this.filter.customerContact) {
                /*
                 * Retrieves only contacts which are already assigned to a unit of the given customer. If a service
                 * company is selected, the query considers only contacts of the selected company.
                 */
                const companyId = this.companyId ? this.companyId : this.customerId;
                Company.contacts(companyId, {
                    customer: this.customerId
                }, (data) => {
                    this.selectable = data;
                });
            } else {
                /*
                 * Retrieves all contacts defined for the given service company or customer.
                 */
                const companyId = this.companyId ? this.companyId : this.customerId;
                Company.contacts(companyId, {
                    customer: null
                }, (data) => {
                    this.selectable = data;
                });
            }
        },

        background (selected, contact) {
            if (selected && selected.id === contact.id) {
                return "background-selected"
            }

            return null;
        },

        contactFilter (item, text) {
            if (!Contact.filter(item, text)) {
                return false;
            }

            if (this.filter.customerContact && this.selectable) {
                const contact = this.selectable.find (c => c.id === item.id);
                const explicitAssignment = !!contact;

                const implicitCustomerAssignment  = item.siteAssignmentType.id === 3 &&
                    (
                       (item.customer && item.customer.id === this.customerId)
                    || (item.company.parent && item.company.parent.id === this.customerId)
                    );

                const implicitGlobalAssignment = item.siteAssignmentType.id === 2;

                if (explicitAssignment || implicitCustomerAssignment || implicitGlobalAssignment) {
                    if (this.filter.customer && !item.roles.find (r => r.id === 2)) {
                        return this.filterStatus(item);
                    }

                    if (this.filter.onsite && item.roles.find (r => r.id === 2)) {
                        return this.filterStatus(item);
                    }

                    return false; //this.filterStatus(item);
                }

                return false;
            }

            if (this.companyId && item.company.id !== this.companyId) {
                return false;
            }

            if (this.filter.customer && !item.roles.find (r => r.id === 2)) {
                return this.filterStatus(item);
            }

            if (this.filter.onsite && item.roles.find (r => r.id === 2)) {
                return this.filterStatus(item);
            }

            return false;
        },

        filterStatus (item) {
            if (this.filter.active && item.status.id < 4) {
                return true;
            }

            if (this.filter.inactive && item.status.id === 4) {
                return true;
            }

            if (this.filter.remove && item.status.id === 5) {
                return true;
            }

            return false;
        }
    }
}

</script>

<style lang="scss" scoped>

</style>

